import React from 'react';

import { sortUtil } from '../layer0';



export function useWrapLazyQueryWithOptions<
  TClientFilter,
  TGqlFilter,
  TGqlSort,
  TClientSortColumnId extends string
>({
  fnClientFilter2Gql, fnClientSort2Gql, fnQueryWithOptions
}: {
  fnClientFilter2Gql: (filter?: TClientFilter) => TGqlFilter;
  fnClientSort2Gql: (sort?: sortUtil.ISortOptions<TClientSortColumnId>) => TGqlSort | undefined;
  fnQueryWithOptions: (options: {
    filter?: TGqlFilter;
    sort?: TGqlSort;
  }) => void;
}) {
  const [filterState, setFilterState] = React.useState<TClientFilter | undefined>(undefined);
  const [sortState, setSortState] = React.useState<sortUtil.ISortOptions<TClientSortColumnId>>({
    columnId: '',
    direction: 'ascending'
  });

  const fnWrappedQuery = React.useCallback(
    ({
      filter, sort
    }: {
      filter?: TClientFilter;
      sort?: sortUtil.ISortOptions<TClientSortColumnId>;
    }) => {
      if (filter) {
        setFilterState(filter);
      }
      if (sort) {
        setSortState(sort);
      }

      fnQueryWithOptions({
        filter: fnClientFilter2Gql(filter ?? filterState),
        sort: fnClientSort2Gql(sort ?? sortState)
      });
    },
    [
      fnQueryWithOptions,
      fnClientFilter2Gql,
      fnClientSort2Gql,
      setFilterState,
      filterState,
      sortState
    ]
  );

  return [
    fnWrappedQuery,
    filterState,
    sortState
  ] as const;
}
